import {ChangeDetectorRef, Component, Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  FormFieldBase
} from "../../../../components/dynamic-form-field/components/dynamic-form-light/models/form-field-base";
import {ProtocolService} from "../../../services/protocol.service";
import {ProtocolOrigin} from "../../../models/protocol";
import {debounceTime, distinctUntilChanged, switchMap} from "rxjs/operators";
import {HelpersService} from "src/app/core/services/helpers.service";
import {Observable, Subject, Subscription} from "rxjs";
import {FileManagerService} from "src/app/core/components/upload-tool/services/file-manager.service";
import {DocumentoAllegato} from "src/app/common/models/documento-allegato";
import {FileUploadResponse} from "src/app/common/models/dto/file-upload-response";
import {ServicePathsSettings} from "src/app/core/configuration/service-paths-settings";
import {HttpClient} from "@angular/common/http";
import {FileData} from "src/app/common/models/file-data";
import {RequestProtocol} from "../../../models/dto/request-fascicolo-protocol";
import {ConfigurationService} from "src/app/common/configuration/services/configuration.service";
import {ConfigurationFeature} from "src/app/common/configuration/models/configuration";
import {ProtocolStore} from "../../../stores/protocol-store";
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';
import { UfficiService } from 'src/app/core/services/ufficiService';
import { MultiSelectComponent } from 'src/app/common/components/input-component/multi-select/multiselect.component';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { MetadatoDocumento } from 'src/app/common/form/documento/document-uploaded/campi';
import { OperationsService } from 'src/app/core/services/operations.service';
import { TipoTipologica } from 'src/app/common/models/tipologiche/tipo-tipologica';
import { UploadDocumentUtilityService } from 'src/app/common/form/documento/document-uploaded/upload-document-utility.service';
@Component({
  selector: "app-protocol-fascicolo-insert",
  templateUrl: "./protocol-fascicolo-insert.component.html",
  styleUrls: ["./protocol-fascicolo-insert.component.css"],
})
export class ProtocolFascicoloInsertComponent implements OnInit, OnChanges ,OnDestroy {
  //@Output() onError= new EventEmitter();
  @Output() onInsert: EventEmitter<RequestProtocol>  = new EventEmitter<RequestProtocol>();
  @Output() onChangeValue = new EventEmitter<{ key: string, event: any }>();
  @Input() isDocumentInserted: boolean = false;
  @Input() documento: DocumentoAllegato;
  @Input() listaDocumenti: DocumentoAllegato[] = [];
  @Input() idPratica: string;
  public formProtocol: FormGroup = ProtocolStore.getInsertForm();
  protected formFields: FormFieldBase[];
  protected formFieldsSender: FormFieldBase[];
  protected formFieldsReceiver: FormFieldBase[];
  persons: any[];
  requestProtocol: RequestProtocol = {} as RequestProtocol;
  personSelected?: any;
  tipiProvenienza: ProtocolOrigin[];
  fileUploaded: boolean;
  fileUploadList: DocumentoAllegato[] = [];
  fileToUpload: any;
  tipoDocumentoOption: TipoDocumento[];
  private valid_files: any[] = [];
  loading: boolean;
  fileUploadedName: string;
  isProtocolEnabled: boolean = false;
  ufficiOptions = [];
  availableOffices =[];
  senderList = [];
  ufficiService: UfficiService;
  selectedUffici = [];
  selectedUfficiSubmit = [];
  maxFileSize: any;
  maxFileSizeMB: number;
  randomId:number;
  remainingChars: number = 250;
  private subs: Subscription = new Subscription();
  tipoProduttore?: 'INTERNO' | 'ESTERNO';
  @ViewChild('multiSelect') multiSelect: MultiSelectComponent;
  ufficiError: string | null = null;
  private ufficiSearch$ = new Subject<string>();

  settingsMittente = {
    singleSelection: false,
    idField: 'id',
    textField: 'label',
    allowSearchFilter: true,
    searchPlaceholderText: 'Cerca',
    accessible:false,
    noDataAvailablePlaceholderText: 'Nessun risultato',
    clearSearchFilter: true,
    defaultOpen: false,
    enableCheckAll:false,
    limitSelection: 1,
    maxHeight: 197,
    showSelectedItemsAtTop: false,
    allowRemoteDataSearch: true,
  };
  settingsDestinatario = {
    singleSelection: false,
    idField: 'id',
    textField: 'label',
    allowSearchFilter: true,
    searchPlaceholderText: 'Cerca',
    accessible:false,
    noDataAvailablePlaceholderText: 'Nessun risultato',
    clearSearchFilter: true,
    defaultOpen: false,
    enableCheckAll:false,
    limitSelection: -1,
    maxHeight: 197,
    showSelectedItemsAtTop: false,
    allowRemoteDataSearch: true,
  };
  @ViewChildren('typeDocSelect') typeDocSelect: QueryList<ElementRef>;

  constructor(
    private configService: ConfigurationService,
    private protocolService: ProtocolService,
    protected helpers: HelpersService,
    private formBuilder: FormBuilder,
    private fileManager: FileManagerService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    ufficiService: UfficiService,
    private dialog: DialogService,
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    protected operationService: OperationsService,
    private uploadUtilityService: UploadDocumentUtilityService
  ) {
    this.ufficiService = ufficiService;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.listaDocumenti?.currentValue?.length) {
      this.requestProtocol.documentProtocol =
        changes.listaDocumenti.currentValue.map(el => {
          const existing = this.requestProtocol.documentProtocol
            ?.find(d => d.documentRef === el.refDocumentale);

          return {
            ...existing,
            documentRef: el.refDocumentale,
            primary: el.primary || false,
            metadatoDocumento: el.metadatoDocumento ?? undefined
          };
        });
    }
  }


  public ngOnInit() {
    this.requestProtocol.documentProtocol = [];
    this.requestProtocol.idPratica = this.idPratica;
    //this.uploadUtilityService.resetTipoProduttoreInitialized();
    if (this.dialogConfig?.data?.protocol) {
      this.isDocumentInserted = this.dialogConfig.data.protocol.isDocumentInserted;
      this.listaDocumenti = this.dialogConfig.data.protocol.listaDocumenti;
      this.documento = this.dialogConfig.data.protocol.documento;

      this.requestProtocol.documentProtocol =
        this.dialogConfig.data.protocol.listaDocumenti.map(el => ({
          documentRef: el.refDocumentale,
          primary: el.primary || false,
          type: el.type ?? null,
          metadatoDocumento: el.metadatoDocumento ?? undefined
        }));
    }
    this.isProtocolEnabled = this.configService.isFeatureEnabled(ConfigurationFeature.PROTOCOL);
    if (this.isProtocolEnabled) {
      this.initForm();
    }
    this.randomId = this.randomId ?? Math.random();
    // this.formProtocol.get('origin').valueChanges.subscribe((origin) => {
    //   //this.toggleValidatorsOrigin(origin);
    //   const senderReceiverGroup = this.formProtocol.get('senderReceiver') as FormGroup;
    //   if(origin && origin.name === 'INTERNO'){
    //     senderReceiverGroup.reset();
    //     this.formProtocol.get('typeSenderReceiver').setValue(null);
    //   }else if (origin && origin.name === 'ESTERNO'){
    //     this.formProtocol.get('codeOfficeList').setValue(null);
    //   }
    // });
    this.configService.getParameter('maxsize').subscribe(
      (response) => {
        if (response.maxSize) {
          this.maxFileSize = response.maxSize;
          this.maxFileSizeMB = Math.round(response.maxSize / 1048576);
        }
      }
    );
    this.formProtocol.get('typeSenderReceiver').valueChanges.subscribe((typeSenderReceiver) => {
      this.toggleValidatorsTypeSender(typeSenderReceiver);
      // if(this.formProtocol.get("arrivoPartenza").value === false && typeSenderReceiver) {
      //   this.selectedUffici = [];
      //   this.formProtocol.get('codeOfficeList').setValue([]);
      // }
    });
    // this.formProtocol.get('codeOfficeList').valueChanges.subscribe(value => {
    //   if(this.formProtocol.get("arrivoPartenza").value === false && value?.length === 1) {
    //     this.resetList();
    //   }
    // })
    //La ricerca degli uffici parte solo 1 secondo dopo l’ultima digitazione
    this.ufficiSearch$.subscribe(value => {
        this.callUfficiService(value);
    });
  }

  ngOnDestroy() {
    if(this.subs){
      this.subs.unsubscribe();
    }
  }

  protected initForm() {
    this.protocolService.getAllOrigins().subscribe((response) => (this.tipiProvenienza = response.items));
    this.helpers.getTipiPersona().subscribe((data) => { this.persons = data; });
    this.helpers.getTipiDocumenti().subscribe(response => {
      this.tipoDocumentoOption = response && response.length > 0
        ? response.sort((a, b) => a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1)
        : [];
    });
    if (!this.formProtocol) {
      this.formProtocol = this.formBuilder.group({
        object: [null, [Validators.required, Validators.maxLength(250)]],
        classe: [null],
        origin: [null],
        arrivoPartenza: [null, Validators.required],
        codeOfficeList: [null],
        typeSenderReceiver: [null],
        datiSensibili:[false],
        notaRiservata:[false],
        senderReceiver: this.formBuilder.group({
          firstName: [null],
          lastName: [null],
          denomination: [null],
          taxNumber: [null],
          inConoscenza: [false],
        }),
      });
      this.formProtocol.get('object').updateValueAndValidity();
      ProtocolStore.setInsertForm(this.formProtocol);
    }
    this.formProtocol.get("arrivoPartenza").valueChanges.subscribe(value => {
      this.formProtocol.get('codeOfficeList').setValue(null);
      this.selectedUffici = [];
      this.resetList();
      //this.fileUploadList = [];
    });
    const objCtrl = this.formProtocol.get('object');
    if (objCtrl) {
      this.remainingChars = 250 - (objCtrl.value ? objCtrl.value.length : 0);
      //Observable che emette un evento ogni volta che il valore del controllo cambia, cioè quando l’utente digita o cancella qualcosa.
      this.subs = (objCtrl.valueChanges).subscribe((v: string) => {
        this.remainingChars = 250 - (v ? v.length : 0);
      });
    }
    // this.uploadUtilityService.tipoProduttoreChanges.subscribe(value => {
    //   if (!value) return;
    //   this.fileUploadList.forEach(f => {
    //     f.metadatoDocumento = {
    //       ...f.metadatoDocumento,
    //       tipoUfficioProduttore: value ? this.mapToTipoTipologica(value.value) : undefined
    //     };
    //   });
    // });
    this.formProtocol.reset();
  }

  private toggleValidatorsTypeSender(typeSenderReceiver: any) {
    const senderReceiverGroup = this.formProtocol.get('senderReceiver') as FormGroup;
    if (!typeSenderReceiver) {
      senderReceiverGroup.get('firstName').clearValidators();
      senderReceiverGroup.get('firstName').updateValueAndValidity();
      senderReceiverGroup.get('lastName').clearValidators();
      senderReceiverGroup.get('lastName').updateValueAndValidity();
      senderReceiverGroup.get('denomination').clearValidators();;
      senderReceiverGroup.get('denomination').updateValueAndValidity();
      return
    };
    // this.formProtocol.get('codeOfficeList').clearValidators();
    // this.formProtocol.get('codeOfficeList').updateValueAndValidity();
    if(typeSenderReceiver.label === 'FISICA') {
      senderReceiverGroup.get('firstName').setValidators([Validators.required,Validators.minLength(1)]);
      senderReceiverGroup.get('firstName').updateValueAndValidity();
      senderReceiverGroup.get('lastName').setValidators([Validators.required,Validators.minLength(1)]);
      senderReceiverGroup.get('lastName').updateValueAndValidity();
      // senderReceiverGroup.get('taxNumber').setValidators([Validators.maxLength(16)]);
      // senderReceiverGroup.get('taxNumber').updateValueAndValidity();
      senderReceiverGroup.get('denomination').clearValidators();
      senderReceiverGroup.get('denomination').updateValueAndValidity();
    } else {
      senderReceiverGroup.get('firstName').clearValidators();
      senderReceiverGroup.get('firstName').updateValueAndValidity();
      senderReceiverGroup.get('lastName').clearValidators();
      senderReceiverGroup.get('lastName').updateValueAndValidity();
      // senderReceiverGroup.get('taxNumber').clearValidators();
      // senderReceiverGroup.get('taxNumber').updateValueAndValidity();
      senderReceiverGroup.get('denomination').setValidators([Validators.required,Validators.minLength(1)]);
      senderReceiverGroup.get('denomination').updateValueAndValidity();
    }
  }

  onMultySelect(event: { key: string, event: any }) {
    this.formProtocol.get('codeOfficeList').setValue(event.event.value);
    this.onChangeValue.emit({ key: event.key.toString(), event: event.event.value })
  }

  private callUfficiService(filterValue: string) {
    // if (filterValue.length >= 4) {
      this.ufficiService.getUffici(filterValue).subscribe({
        next: res => {
          let map = res.items.map(x => ({
            id: x.idUo,
            descrizione: x.description,
            label: x.label
          }));
          this.ufficiOptions = map;
          this.ufficiError = null;
          this.updateAvailableOffices();
        },
        error: err => {
          let msg = err.error || "";
          const normalizedMsg = msg.toLowerCase();

          if (normalizedMsg.includes("criteri di ricerca")) {
            this.ufficiError = "Inserire criteri di ricerca più restrittivi";
          } else {
            this.openDialogShowWarning("Qualcosa é andato storto, contattare l'amministratore!");
          }
          this.ufficiOptions = [];
        }
      });
    // }
  }

  //filterUffici si limita a emettere i valori nel Subject
  filterUffici(event: string) {
    if (!event) {
      this.ufficiOptions = [];
      this.ufficiError = null;
      return;
    }
    this.ufficiSearch$.next(event);
  }


  // filterUffici(event) {
  //   if(!event) {
  //     this.ufficiOptions = [];
  //     return;
  //   }
  //   let filterValue = event;
  //   // Verifico la lunghezza del filtro almeno 3 caratteri prima di effettuare la chiamata al backend
  //   if (filterValue.length >= 4) {
  //     // this.ufficiService.getAllOfficeTypes(filterValue).pipe(debounceTime(5000)).subscribe(res => {
  //     this.ufficiService.getUffici(filterValue).pipe(debounceTime(5000)).subscribe(res => {
  //       let map = res.items.map(x => {
  //         return {
  //           id: x.idUo,
  //           descrizione: x.description,
  //           label: x.label
  //         };
  //       });
  //       this.ufficiOptions = map;
  //       this.updateAvailableOffices();
  //     });
  //   }
  // }

  openDialogShowWarning(msg) {
    const ref = this.dialog.open(ConfirmModalComponent, {
      data: {
          modalConfirm: {
            text: msg,
            confirmButton: true,
            hideButtons: true,
            data: []
          },
          style: { width: "50%" },
          title: "Conferma",
        }
      });
      ref.afterClosed.subscribe();
  }

  changeTipoPersona(tipoPersona: any) {
    const senderReceiverGroup = this.formProtocol.get('senderReceiver') as FormGroup;
    if (tipoPersona?.label === 'GIURIDICA') {
      senderReceiverGroup.get('denomination').setValue(null);

    } else {
      senderReceiverGroup.get('firstName').setValue(null);
      senderReceiverGroup.get('lastName').setValue(null);
      senderReceiverGroup.get('taxNumber').setValue(null);
    }
  }

  protected onSubmit(event) {
    let totalFileSize = this.fileUploadList.reduce((total, file) => total + file.contentSize, 0);
    // Controllo della dimensione totale se eccede il limite massimo
    if (totalFileSize > this.maxFileSize) {
      this.openErrorDialog(`La dimensione totale dei file allegati è troppo grande.`);
      return;
    }
    this.requestProtocol.subject = this.formProtocol.value.object;
    //this.requestProtocol.origin = this.formProtocol.value.origin.id;
    //this.requestProtocol.classe = this.formProtocol.value.classe.id;
    this.requestProtocol.arrivoPartenza = this.formProtocol.value.arrivoPartenza;
    this.requestProtocol.notaRiservata = this.formProtocol.value.notaRiservata ? this.formProtocol.value.notaRiservata : false;
    this.requestProtocol.datiSensibili =  this.formProtocol.value.datiSensibili ? this.formProtocol.value.datiSensibili : false;
    this.requestProtocol.codeOfficeList = this.selectedUfficiSubmit.map(x => {
      const inConoscenza = this.requestProtocol.arrivoPartenza
      ? (x.inConoscenza !== undefined ? x.inConoscenza : false)
      : undefined; // Non includere inConoscenza se non è in arrivo/partenza
      return {id: x.id, inConoscenza: inConoscenza}
    }).filter((value, index, self) =>
      index === self.findIndex((t) => t.id === value.id)  //mantiene solo la prima occorrenza di ciascun id nell'array.
    );
    this.requestProtocol.senderReceiver = [];
    this.senderList.forEach((elem) => {
      const inConoscenza = this.requestProtocol.arrivoPartenza
      ? (elem.inConoscenza !== undefined ? elem.inConoscenza : false)
      : undefined; // Non includere inConoscenza se non è in arrivo/partenza
      if (elem.type == "GIURIDICA") {
        this.requestProtocol.senderReceiver.push({
          denomination: elem.denomination,
          type: elem.type,
          inConoscenza: inConoscenza
        })
      }
      if (elem.type == "FISICA") {
        this.requestProtocol.senderReceiver.push({
          firstName: elem.firstName,
          lastName: elem.lastName,
          type: elem.type,
          taxNumber: elem.taxNumber || "",
          inConoscenza: inConoscenza
        })
      }
    })
    if(this.requestProtocol.arrivoPartenza){
      let allDestinatari = [...this.requestProtocol.codeOfficeList, ...this.requestProtocol.senderReceiver];
      const hasAtLeastOneMain = allDestinatari.some(dest => dest.inConoscenza === false);
      if (this.requestProtocol.senderReceiver.length === 0) {
        const piuUfficiConConoscenza = this.requestProtocol.codeOfficeList.filter(office => office.inConoscenza === true);
        const piuUfficiPrincipale = this.requestProtocol.codeOfficeList.filter(office => office.inConoscenza === false);
        if (piuUfficiConConoscenza.length === this.requestProtocol.codeOfficeList.length) {
          this.openErrorDialog("Attenzione: tutti i destinatari interni sono stati impostati come 'per conoscenza'. Per procedere, è necessario che un Ufficio sia il principale");
          return;
        }
        // else if (piuUfficiPrincipale.length > 1) {
        //   this.openErrorDialog("Attenzione: più di un destinatario interno è stato impostato come 'principale'. Per procedere, è necessario che solo un Ufficio sia il principale");
        //   return;
        // }
      }else if (!hasAtLeastOneMain) {
        this.openErrorDialog("Attenzione: tutti i destinatari sono stati impostati come 'per conoscenza'. È necessario che almeno un destinatario sia il principale");
        return;
      }
    }
     this.requestProtocol.documentProtocol =
        this.requestProtocol.documentProtocol.map(dp => {
          const file = this.fileUploadList.find(
            f => f.refDocumentale === dp.documentRef
          );
          return {
            ...dp,
            metadatoDocumento: file?.metadatoDocumento
          };
      });
    this.onInsert.emit(this.requestProtocol);
    this.dialogRef.close({protocol: this.requestProtocol});
  }

  isDropdownDisabled(): boolean {
    const arrivoPartenza = this.formProtocol.get('arrivoPartenza')?.value;
    const hasExistingUfficio = this.senderList.some(sender => sender.offices && sender.offices.length > 0);

    return !arrivoPartenza && hasExistingUfficio;
  }

  isTypeSenderReceiverDisabled(): boolean {
    const arrivoPartenza = this.formProtocol.get('arrivoPartenza')?.value;
    const hasExistingTipoPersona = this.senderList.some(
      sender => (sender.type === 'GIURIDICA' || sender.type === 'FISICA') && sender.type.length > 0
    );

    return !arrivoPartenza && hasExistingTipoPersona;
  }

  showAddUfficioButton(): boolean {
    let arrivoPartenza = this.formProtocol.get('arrivoPartenza').value;
    let hasSelectedUffici = this.selectedUffici.length > 0;
    let hasExistingUfficio = this.senderList.some(sender => sender.offices && sender.offices.length > 0);
    return (arrivoPartenza && hasSelectedUffici) || (!arrivoPartenza && hasSelectedUffici &&!hasExistingUfficio);
  }

  showAddMittenteDestinatarioButton(): boolean{
    let arrivoPartenza = this.formProtocol.get('arrivoPartenza').value;
    let hasExistingTipoPersona = this.senderList?.some(sender => sender.type === 'GIURIDICA' || sender.type === 'FISICA' && sender.type.length > 0);
    return (!arrivoPartenza && !hasExistingTipoPersona);
  }

  openErrorDialog(message:string){
    this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: message,
          data: [],
          hideButtons: true,
          confirmButton :true
        },
        style: {
          width: '50%',
          zIndex: '9999999 !important'
        },
        title: 'Nuovo protocollo',
      }
    });
  }

  protected onReset() {
    // reset form
    this.formProtocol.reset();

    // reset stato applicativo
    this.senderList = [];
    this.selectedUffici = [];
    this.selectedUfficiSubmit = [];

    // reset file
    this.fileUploadList = [];
    this.valid_files = [];
    this.fileToUpload = null;
    this.fileUploaded = false;
    this.fileUploadedName = '';

    // reset protocol
    this.requestProtocol.documentProtocol = [];
    //this.uploadUtilityService.resetTipoProduttoreInitialized();

    this.cdr.detectChanges();
  }

  //DOCUMENTO UPLOAD

  uploadFile(file: File, isLastOne?): Observable<FileUploadResponse> {
    return this.fileManager
      .getPayloadFile(file)
      .pipe(switchMap((res) => this.getObsFileUploadResponse(res)));
  }
  setFileDataRequest(fileData: FileData) {
    if(this.requestProtocol.documentProtocol == null){
      this.requestProtocol.documentProtocol = [];
    }
    let primaryPresent: boolean = this.requestProtocol.documentProtocol.some(elem => elem.primary);
    this.requestProtocol.documentProtocol.push({
      documentRef: fileData.refDocumentale,
      primary: !primaryPresent,
      type:null,
      metadatoDocumento: undefined
    });
    let fileDaAllegare = new DocumentoAllegato();
    fileDaAllegare.refDocumentale = fileData.refDocumentale;
    fileDaAllegare.nomeFile = fileData.nomeFile;
    fileDaAllegare.contentType = fileData.contentType;
    fileDaAllegare.contentSize = fileData.contentSize;
    fileDaAllegare.signedData = fileData.signedData ?? null;
    fileDaAllegare.algoritmoImprontaDocumento = fileData.algoritmoImprontaDocumento;
    fileDaAllegare.improntaDocumento = fileData.improntaDocumento;
    fileDaAllegare.metadatoDocumento = {
      modalitaFormazioneDocumento: { id: 'A', descrizione: '', label: '', rimosso: false },
      tipoUfficioProduttore: { id: 'ESTERNO', descrizione: '', label: '', rimosso: false }
    };
    this.fileUploadList.push(fileDaAllegare);
  }

  onTypeDocChange(event, item) {
    let index = this.requestProtocol.documentProtocol.findIndex(el => el.documentRef === item.refDocumentale);
    if(index > -1) {
      this.requestProtocol.documentProtocol[index].type = event.target.value === "null" ? null : event.target.value;
    }
  }

  onSearchChange(fileInput: any) {
    let files = fileInput;
    this.loading = true;
    // if (files.length > 0) {
    //   let files = fileInput.target.files;
    // }
    for (var i = 0; i < files.length; i++) {
      this.fileToUpload = files[i];
      this.valid_files.push(files[i]);
      this.uploadFile(
        this.fileToUpload,
        Number(i) == files.length - 1
      ).subscribe((res) => {
        if (res && res.fileData) {
          this.setFileDataRequest(res.fileData);
          this.fileUploaded = true;
          this.fileUploadedName = res.fileData.nomeFile;
          //this.onReturn.emit(res.fileData)
        }
      });
    }
    this.loading = false;
  }

  private getObsFileUploadResponse(payload: {
    fileData: {};
  }): Observable<FileUploadResponse> {
    return this.http.post<FileUploadResponse>(
      this.getUrlUploadDocumento(),
      payload,
      { withCredentials: true }
    );
  }

  deleteFile(refDocumentale: string, index: number) {
    let itemDeleted = this.requestProtocol.documentProtocol.splice(this.requestProtocol.documentProtocol.findIndex(elem => elem.documentRef === refDocumentale),1);
    if(itemDeleted[0].primary && this.requestProtocol.documentProtocol.length > 0){
      this.requestProtocol.documentProtocol[0].primary = true;
    }
    this.fileUploadList.splice(index,1);
  }

  getUrlUploadDocumento() {
    return (
      ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_UPLOAD_DOCUMENTO
    );
  }

  addMittenteDestinatario(){
    const sender = this.formProtocol.get('senderReceiver') as FormGroup;
    this.senderList.push({
      type: this.formProtocol.get('typeSenderReceiver').value?.label,
      firstName: sender.get('firstName').value,
      lastName: sender.get('lastName').value,
      taxNumber: sender.get("taxNumber").value,
      denomination: sender.get("denomination").value
    })
    sender.get("firstName").setValue(null);
    sender.get("lastName").setValue(null);
    sender.get("taxNumber").setValue(null);
    sender.get("denomination").setValue(null);
    sender.get('firstName').clearValidators();
    sender.get('firstName').updateValueAndValidity();
    sender.get('lastName').clearValidators();
    sender.get('lastName').updateValueAndValidity();
    sender.get("denomination").clearValidators();
    sender.get("denomination").updateValueAndValidity();
    this.formProtocol.get('typeSenderReceiver').setValue(null);
  }

  addUfficio(){
    const selectedOffices = this.formProtocol.get('codeOfficeList').value || [];
    let newOffices = [];
    const officesInSenderList = this.senderList
    .filter(sender => sender.offices)
    .flatMap(sender => sender.offices);
    if(officesInSenderList && officesInSenderList.length > 0){
       newOffices = selectedOffices.filter(selectedOffice => {
        return !officesInSenderList.some(office => office.id === selectedOffice.id)
      });
    } else {
      newOffices = selectedOffices
    }
    this.senderList.push({
      offices: newOffices
    })
    // Aggiorna la lista degli uffici disponibili
    this.updateAvailableOffices();
    this.ufficiOptions = [];
    this.formProtocol.get('codeOfficeList').setValue([]);
    this.multiSelect.reset();
    this.selectedUffici = [];
  }

  updateAvailableOffices(): void {
    const selectedOffices = this.senderList
    .filter(sender => sender.offices)
    .flatMap(sender => sender.offices);
    if(selectedOffices && selectedOffices.length != 0){
      this.availableOffices  = this.ufficiOptions.filter(office =>
        !selectedOffices.some(selectedOffice => selectedOffice.id === office.id)
      );
      this.ufficiOptions = this.availableOffices;
    }
  }

  deleteSender(index: number){
    this.senderList.splice(index, 1);
  }

  deleteOffice(senderIndex: number, officeIndex: number): void {
    this.senderList[senderIndex].offices.splice(officeIndex, 1);
    this.selectedUfficiSubmit.splice(officeIndex,1);
    this.updateAvailableOffices();
  }

  onFlagNotaRiservataChange(value: any) {
    this.formProtocol.get('notaRiservata').setValue(value);
  }

  onFlagDatiSensibiliChange(value: any) {
    this.formProtocol.get('datiSensibili').setValue(value);
  }

  onForConoscenzaChange(sender: any, index: number) {
    // console.log(`Checkbox for sender at index ${index} changed to: ${sender.forConoscenza}`);
  }

  onForConoscenzaOfficeChange(senderIndex: number, officeIndex: number): void {
    const selectedOffice = this.senderList[senderIndex].offices[officeIndex];
    // console.log(`Office index: ${officeIndex}, inConoscenza: ${selectedOffice.inConoscenza}`);
  }

  onReturnHandler(event: any) {
    this.formProtocol.get('arrivoPartenza').setValue(event);
  }

  resetList() {
    this.senderList = [];
    const sender = this.formProtocol.get('senderReceiver') as FormGroup;
    sender.get("firstName").setValue(null);
    sender.get("lastName").setValue(null);
    sender.get("taxNumber").setValue(null);
    sender.get("inConoscenza").setValue(null);
    sender.get("denomination").setValue(null);
    this.formProtocol.get("typeSenderReceiver").setValue(null);
  }

  checkSenderList(){
    return !!this.senderList && this.senderList.length > 0;
  }

  getPrimary(documentRef: string): boolean{
    return this.requestProtocol.documentProtocol.some(elem => elem.documentRef === documentRef && elem.primary);
  }

  changePrimary(documentRef: string) {
    this.requestProtocol.documentProtocol.forEach(m => {
      m.primary = (m.documentRef === documentRef);
      m.type = null;
    });

    this.typeDocSelect.forEach(el => {
      const currentType= el.nativeElement.value;
      const isPrimary = this.requestProtocol.documentProtocol.some(m => m.type === currentType && m.primary);

    if (!isPrimary && currentType !== this.requestProtocol.documentProtocol.find(m => m.documentRef === documentRef)?.type) {
      el.nativeElement.value = null;
    }
  });

    this.cdr.detectChanges();
  }



  onEditCell(event: {event: string, index: number, type: string}) {
    this.senderList[event.index][event.type] = event.event;
  }

  edit(index) {
    this.senderList[index].edit = !this.senderList[index].edit;
  }

  onItemSelect(event: {id: string, label: string}) {
    this.selectedUffici = [...this.selectedUffici, ...[event]];
    this.formProtocol.get('codeOfficeList').setValue(this.selectedUffici);
    this.selectedUfficiSubmit.push(event);
    // this.onChangeValue.emit({ key: event.id.toString(), event: event.label })
  }

  onItemDeSelect(event: {id: string, label: string}) {
    let index = this.selectedUffici.findIndex(x => x.id === event.id)
    this.selectedUffici.splice(index, 1);
    this.formProtocol.get('codeOfficeList').setValue(this.selectedUffici);
    // Rimuovi l'elemento deselezionato da selectedUfficiSubmit
    this.selectedUfficiSubmit.splice(index, 1);
  }

  checkFormValidity() {
    const hasInvalidInternalDoc = this.fileUploadList.some(file =>
      file?.signedData?.statoFirma === 'NON_VALIDA' &&
      file?.metadatoDocumento?.tipoUfficioProduttore?.id === 'INTERNO'
    );
    if (hasInvalidInternalDoc) {
      return false;
    }

    // Controlla che tutti i file abbiano tipoUfficioProduttore valorizzato
    const allFilesHaveTipoUfficio = this.fileUploadList.every(file =>
      file.metadatoDocumento?.tipoUfficioProduttore
    );
    if (!allFilesHaveTipoUfficio) return false;

    let formIsValid: boolean = this.formProtocol.get('object').valid && this.formProtocol.get('arrivoPartenza').valid;
    let secondCondition: boolean = this.senderList?.length > 0 || this.selectedUffici.length > 0;
    let thirdCondition: boolean = (this.requestProtocol.documentProtocol && this.requestProtocol.documentProtocol.length > 0) || this.isDocumentInserted;
    let fourthCondition: boolean = (this.requestProtocol.documentProtocol && Array.isArray(this.requestProtocol.documentProtocol) && this.requestProtocol.documentProtocol.findIndex(itm => !itm.type) === -1) ||
      this.listaDocumenti.length > 0;
    let arrivoPartenza = this.formProtocol.get("arrivoPartenza").value;
    let arrivoPartenzaCondition: boolean = arrivoPartenza === false &&
    this.senderList?.some(sender => sender.offices && sender.offices.length > 0) &&
    this.senderList?.some(sender => sender.type === 'GIURIDICA' || sender.type === 'FISICA');
    const value: boolean = formIsValid && secondCondition && thirdCondition && fourthCondition && (arrivoPartenza || arrivoPartenzaCondition);

    return value;
  }

  onExtractArchive(event: {response: any, refDocumentale:string}) {
    const documenti: FileData[] = event.response.filesData;
    for (const element of documenti) {
      this.setFileDataRequest(element);
    }
    // rimuove lo zip
    let index = this.fileUploadList.findIndex(x => x.refDocumentale === event.refDocumentale);
    this.fileUploadList.splice(index, 1);
    // rimuove lo ZIP/EML dalla requestProtocol
    const indexProtocol = this.requestProtocol.documentProtocol.findIndex(
    d => d.documentRef === event.refDocumentale
    );
    if (indexProtocol !== -1) {
      this.requestProtocol.documentProtocol.splice(indexProtocol, 1);
    }
  }



  onDocReturn(event: any) {
    if (!event || !event.refDocumentale) return;
    this.tipoProduttore = event.tipoUfficioProduttore;
    const newDoc = {
      documentRef: event.refDocumentale,
      primary: event.primary,
      type: event.type
    };

    const existingIndex = this.requestProtocol.documentProtocol
      .findIndex(d => d.documentRef === newDoc.documentRef);

      if (existingIndex !== -1) {
        // aggiorna solo i valori passati
        this.requestProtocol.documentProtocol[existingIndex] = {
          ...this.requestProtocol.documentProtocol[existingIndex],
          ...newDoc
        };
      } else {
        this.requestProtocol.documentProtocol.push(newDoc);
      }
      const idx = this.fileUploadList.findIndex(f => f.refDocumentale === event.refDocumentale);
      if (idx === -1) return;
      if (idx > -1) {
        const doc = this.fileUploadList[idx];
        const nuovoMetadato: MetadatoDocumento = {
          modalitaFormazioneDocumento: this.mapToTipoTipologica(event.modalitaFormazioneDocumento),
          motivoAssenzaFirma: this.mapToTipoTipologica(event.motivoAssenzaFirma),
          documentoUnico: event.documentoUnico,
          tipoUfficioProduttore: this.mapToTipoTipologica(
            event.tipoUfficioProduttore ?? 'ESTERNO'
          ),
          ufficioProduttore: event.ufficioProduttore,
          numDocumentiScansione: event.numDocumentiScansione,
          documentiScansionati: event.documentiScansionati
        };
      doc.metadatoDocumento = nuovoMetadato;
      this.fileUploadList = [...this.fileUploadList];
    }
  }

  mapToTipoTipologica = (key?: string): TipoTipologica | undefined => {
    if (!key) return undefined;
    return { id: key, descrizione: '', label: '', rimosso: false };
  };
}


